<script>
    export default {
        props: {
            data: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        data() {
            return { ...this.data };
        },

        watch: {
            module() {
                this.section = null;
            },

            section() {
                this.form_field = null;
            },

            form_field() {
                if (this.form_field) {
                    this.$refs.form.submit();
                }
            },
        },
    };
</script>
